import React, { createContext, useState } from "react";
import Logger from "../../../utils/Logger";
import useDetectFullScreenStyle from "../../hooks/public/useDetectFullScreenStyle";

const Log = Logger.getLogger("PublicComponentsWrap");

export type PublicComponentsWrapContextType = {
	isFullScreen: boolean,
	isDialogOpen: boolean,
	setIsDialogOpen:(val: boolean) => void,
	reloadTrigger: number,
	setReloadTrigger: (val: number | ((prev: number) => number)) => void;
};

export const PublicComponentsWrapContext = createContext<PublicComponentsWrapContextType | null>(null);

export default function PublicComponentsWrap(props: { children: JSX.Element | JSX.Element[] | string | string[] }) {

	const { isFullScreen } = useDetectFullScreenStyle();
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [reloadTrigger, setReloadTrigger] = useState(0);


	

	return (
		<PublicComponentsWrapContext.Provider value={{
			isFullScreen: isFullScreen,
			isDialogOpen: isDialogOpen,
			setIsDialogOpen: setIsDialogOpen,
			setReloadTrigger: setReloadTrigger,
			reloadTrigger: reloadTrigger,

		}}>
			<div className="public-components-wrap">
				<div className="public-components-wrap-inner">{props?.children}</div>
			</div>
		</PublicComponentsWrapContext.Provider>
	);
}
